export const IPLogoGradient = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M14 1.84211C7.28538 1.84211 1.84211 7.28538 1.84211 14C1.84211 20.7146 7.28538 26.1579 14 26.1579C20.7146 26.1579 26.1579 20.7146 26.1579 14C26.1579 7.28538 20.7146 1.84211 14 1.84211ZM0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
			fill="url(#paint0_linear_2129_44957)"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.34868 3.7763C6.27115 3.7763 3.77632 6.27114 3.77632 9.34867C3.77632 12.4262 6.27115 14.921 9.34868 14.921C12.4262 14.921 14.9211 12.4262 14.9211 9.34867C14.9211 6.27114 12.4262 3.7763 9.34868 3.7763ZM1.93421 9.34867C1.93421 5.25377 5.25378 1.9342 9.34868 1.9342C13.4436 1.9342 16.7632 5.25377 16.7632 9.34867C16.7632 13.4436 13.4436 16.7631 9.34868 16.7631C5.25378 16.7631 1.93421 13.4436 1.93421 9.34867Z"
			fill="url(#paint1_linear_2129_44957)"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.6382 7.09209C8.67973 7.09209 7.0921 8.67971 7.0921 10.6381C7.0921 12.5966 8.67973 14.1842 10.6382 14.1842C12.5966 14.1842 14.1842 12.5966 14.1842 10.6381C14.1842 8.67971 12.5966 7.09209 10.6382 7.09209ZM5.25 10.6381C5.25 7.66235 7.66236 5.24999 10.6382 5.24999C13.614 5.24999 16.0263 7.66235 16.0263 10.6381C16.0263 13.6139 13.614 16.0263 10.6382 16.0263C7.66236 16.0263 5.25 13.6139 5.25 10.6381Z"
			fill="url(#paint2_linear_2129_44957)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_2129_44957"
				x1="-0.0100631"
				y1="-4.39325e-07"
				x2="28.0477"
				y2="28.0578"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#B642CB" />
				<stop offset="1" stop-color="#353DD5" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_2129_44957"
				x1="-0.0100631"
				y1="-4.39325e-07"
				x2="28.0477"
				y2="28.0578"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#B642CB" />
				<stop offset="1" stop-color="#353DD5" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_2129_44957"
				x1="-0.0100631"
				y1="-4.39325e-07"
				x2="28.0477"
				y2="28.0578"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#B642CB" />
				<stop offset="1" stop-color="#353DD5" />
			</linearGradient>
		</defs>
	</svg>
)
export const IPLogo = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="241" height="104" viewBox="0 0 241 104" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M120.456 4.27211C104.884 4.27211 92.2604 16.8958 92.2604 32.468C92.2604 48.0402 104.884 60.6639 120.456 60.6639C136.028 60.6639 148.652 48.0402 148.652 32.468C148.652 16.8958 136.028 4.27211 120.456 4.27211ZM87.9883 32.468C87.9883 14.5364 102.525 0 120.456 0C138.388 0 152.924 14.5364 152.924 32.468C152.924 50.3996 138.388 64.936 120.456 64.936C102.525 64.936 87.9883 50.3996 87.9883 32.468Z"
			fill="currentColor"></path>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M109.669 8.75779C102.532 8.75779 96.7461 14.5437 96.7461 21.6809C96.7461 28.8182 102.532 34.604 109.669 34.604C116.806 34.604 122.592 28.8182 122.592 21.6809C122.592 14.5437 116.806 8.75779 109.669 8.75779ZM92.474 21.6809C92.474 12.1842 100.173 4.48568 109.669 4.48568C119.166 4.48568 126.864 12.1842 126.864 21.6809C126.864 31.1776 119.166 38.8761 109.669 38.8761C100.173 38.8761 92.474 31.1776 92.474 21.6809Z"
			fill="currentColor"></path>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M112.66 16.4476C108.118 16.4476 104.436 20.1295 104.436 24.6714C104.436 29.2133 108.118 32.8952 112.66 32.8952C117.202 32.8952 120.883 29.2133 120.883 24.6714C120.883 20.1295 117.202 16.4476 112.66 16.4476ZM100.164 24.6714C100.164 17.7701 105.758 12.1755 112.66 12.1755C119.561 12.1755 125.156 17.7701 125.156 24.6714C125.156 31.5727 119.561 37.1673 112.66 37.1673C105.758 37.1673 100.164 31.5727 100.164 24.6714Z"
			fill="currentColor"></path>
		<path d="M0 102.952V75.1401H5.24444V102.952H0Z" fill="currentColor"></path>
		<path
			d="M10.6348 102.952V83.2452H15.5614V85.8276H16.2765C16.5943 85.139 17.1903 84.4901 18.0644 83.8809C18.9385 83.2452 20.2628 82.9273 22.0374 82.9273C23.5737 82.9273 24.9113 83.2849 26.0502 84C27.2157 84.6887 28.1162 85.6555 28.7519 86.9004C29.3876 88.1188 29.7054 89.5491 29.7054 91.1913V102.952H24.6994V91.5886C24.6994 90.1053 24.3286 88.9929 23.5869 88.2512C22.8718 87.5096 21.8388 87.1388 20.4879 87.1388C18.9517 87.1388 17.7598 87.6553 16.9122 88.6883C16.0646 89.6948 15.6408 91.1118 15.6408 92.9394V102.952H10.6348Z"
			fill="currentColor"></path>
		<path
			d="M38.706 102.952L32.4285 83.2452H37.7524L42.3215 99.2963H43.0366L47.6056 83.2452H52.9295L46.6521 102.952H38.706Z"
			fill="currentColor"></path>
		<path
			d="M64.7376 103.508C62.7775 103.508 61.0426 103.097 59.5329 102.276C58.0496 101.429 56.8842 100.25 56.0366 98.7401C55.2155 97.2038 54.8049 95.4027 54.8049 93.3367V92.86C54.8049 90.794 55.2155 89.0061 56.0366 87.4963C56.8577 85.9601 58.0099 84.7814 59.4931 83.9603C60.9764 83.1127 62.6981 82.6889 64.6581 82.6889C66.5917 82.6889 68.2736 83.126 69.7039 84C71.1342 84.8476 72.2467 86.0395 73.0413 87.5758C73.8359 89.0856 74.2332 90.8469 74.2332 92.86V94.5684H59.8904C59.9434 95.9192 60.4467 97.0184 61.4002 97.866C62.3537 98.7136 63.5192 99.1374 64.8965 99.1374C66.3003 99.1374 67.3333 98.8328 67.9955 98.2236C68.6577 97.6144 69.1609 96.939 69.5052 96.1973L73.5975 98.3428C73.2267 99.0315 72.6837 99.7863 71.9685 100.607C71.2799 101.402 70.3528 102.091 69.1874 102.673C68.022 103.23 66.5387 103.508 64.7376 103.508ZM59.9302 90.8337H69.1477C69.0417 89.6948 68.5782 88.781 67.7571 88.0923C66.9625 87.4036 65.9163 87.0593 64.6184 87.0593C63.2676 87.0593 62.1948 87.4036 61.4002 88.0923C60.6056 88.781 60.1156 89.6948 59.9302 90.8337Z"
			fill="currentColor"></path>
		<path
			d="M78.6889 102.952V83.2452H83.6155V85.4701H84.3307C84.622 84.6755 85.0988 84.0927 85.761 83.7219C86.4496 83.3511 87.2442 83.1657 88.1448 83.1657H90.5286V87.6155H88.0653C86.794 87.6155 85.7477 87.9599 84.9266 88.6485C84.1055 89.3107 83.695 90.3437 83.695 91.7475V102.952H78.6889Z"
			fill="currentColor"></path>
		<path
			d="M102.16 103.508C99.5911 103.508 97.4854 102.952 95.8432 101.839C94.201 100.727 93.2078 99.1374 92.8634 97.0714L97.4722 95.8795C97.6576 96.8065 97.9622 97.5349 98.386 98.0647C98.8363 98.5944 99.3792 98.9785 100.015 99.2169C100.677 99.4288 101.392 99.5347 102.16 99.5347C103.326 99.5347 104.187 99.3361 104.743 98.9387C105.299 98.515 105.577 97.9985 105.577 97.3893C105.577 96.7801 105.312 96.3165 104.783 95.9987C104.253 95.6544 103.405 95.3762 102.24 95.1643L101.127 94.9657C99.7501 94.7008 98.4919 94.3432 97.353 93.893C96.214 93.4162 95.3002 92.7673 94.6116 91.9462C93.9229 91.1251 93.5786 90.0656 93.5786 88.7677C93.5786 86.8077 94.2937 85.3112 95.724 84.2782C97.1543 83.2187 99.0349 82.6889 101.366 82.6889C103.564 82.6889 105.392 83.1789 106.849 84.159C108.305 85.139 109.259 86.4236 109.709 88.0128L105.061 89.4431C104.849 88.4366 104.412 87.7215 103.75 87.2977C103.114 86.8739 102.319 86.662 101.366 86.662C100.412 86.662 99.6838 86.8342 99.1806 87.1785C98.6773 87.4963 98.4257 87.9466 98.4257 88.5293C98.4257 89.165 98.6906 89.6418 99.2203 89.9596C99.7501 90.251 100.465 90.4761 101.366 90.6351L102.478 90.8337C103.961 91.0986 105.299 91.4562 106.491 91.9064C107.709 92.3302 108.663 92.9527 109.352 93.7738C110.067 94.5684 110.424 95.6543 110.424 97.0317C110.424 99.0977 109.669 100.7 108.16 101.839C106.676 102.952 104.677 103.508 102.16 103.508Z"
			fill="currentColor"></path>
		<path
			d="M123.79 103.508C121.83 103.508 120.095 103.097 118.586 102.276C117.102 101.429 115.937 100.25 115.089 98.7401C114.268 97.2038 113.858 95.4027 113.858 93.3367V92.86C113.858 90.794 114.268 89.0061 115.089 87.4963C115.91 85.9601 117.063 84.7814 118.546 83.9603C120.029 83.1127 121.751 82.6889 123.711 82.6889C125.644 82.6889 127.326 83.126 128.757 84C130.187 84.8476 131.299 86.0395 132.094 87.5758C132.889 89.0856 133.286 90.8469 133.286 92.86V94.5684H118.943C118.996 95.9192 119.499 97.0184 120.453 97.866C121.406 98.7136 122.572 99.1374 123.949 99.1374C125.353 99.1374 126.386 98.8328 127.048 98.2236C127.71 97.6144 128.214 96.939 128.558 96.1973L132.65 98.3428C132.279 99.0315 131.736 99.7863 131.021 100.607C130.333 101.402 129.406 102.091 128.24 102.673C127.075 103.23 125.591 103.508 123.79 103.508ZM118.983 90.8337H128.2C128.094 89.6948 127.631 88.781 126.81 88.0923C126.015 87.4036 124.969 87.0593 123.671 87.0593C122.32 87.0593 121.248 87.4036 120.453 88.0923C119.658 88.781 119.168 89.6948 118.983 90.8337Z"
			fill="currentColor"></path>
		<path
			d="M144.921 103.295V75.4838H156.363C158.111 75.4838 159.648 75.8414 160.972 76.5566C162.323 77.2452 163.369 78.2252 164.111 79.4966C164.879 80.768 165.263 82.2778 165.263 84.0259V84.5821C165.263 86.3038 164.866 87.8136 164.071 89.1114C163.303 90.3828 162.243 91.3761 160.893 92.0912C159.568 92.7799 158.058 93.1242 156.363 93.1242H150.165V103.295H144.921ZM150.165 88.3565H155.847C157.092 88.3565 158.098 88.0122 158.866 87.3235C159.634 86.6349 160.019 85.6946 160.019 84.5027V84.1054C160.019 82.9134 159.634 81.9732 158.866 81.2845C158.098 80.5958 157.092 80.2515 155.847 80.2515H150.165V88.3565Z"
			fill="currentColor"></path>
		<path
			d="M177.969 103.508C176.009 103.508 174.247 103.11 172.684 102.316C171.122 101.521 169.89 100.369 168.99 98.8593C168.089 97.3495 167.639 95.5352 167.639 93.4162V92.7805C167.639 90.6615 168.089 88.8472 168.99 87.3374C169.89 85.8277 171.122 84.6755 172.684 83.8809C174.247 83.0862 176.009 82.6889 177.969 82.6889C179.929 82.6889 181.69 83.0862 183.253 83.8809C184.816 84.6755 186.047 85.8277 186.948 87.3374C187.848 88.8472 188.299 90.6615 188.299 92.7805V93.4162C188.299 95.5352 187.848 97.3495 186.948 98.8593C186.047 100.369 184.816 101.521 183.253 102.316C181.69 103.11 179.929 103.508 177.969 103.508ZM177.969 99.0579C179.505 99.0579 180.776 98.5679 181.783 97.5879C182.789 96.5814 183.293 95.1511 183.293 93.297V92.8997C183.293 91.0456 182.789 89.6285 181.783 88.6485C180.803 87.642 179.531 87.1388 177.969 87.1388C176.432 87.1388 175.161 87.642 174.155 88.6485C173.148 89.6285 172.645 91.0456 172.645 92.8997V93.297C172.645 95.1511 173.148 96.5814 174.155 97.5879C175.161 98.5679 176.432 99.0579 177.969 99.0579Z"
			fill="currentColor"></path>
		<path
			d="M192.919 102.952V83.2452H197.926V102.952H192.919ZM195.422 80.9408C194.522 80.9408 193.754 80.6494 193.118 80.0667C192.509 79.484 192.204 78.7159 192.204 77.7623C192.204 76.8088 192.509 76.0407 193.118 75.458C193.754 74.8753 194.522 74.5839 195.422 74.5839C196.35 74.5839 197.118 74.8753 197.727 75.458C198.336 76.0407 198.641 76.8088 198.641 77.7623C198.641 78.7159 198.336 79.484 197.727 80.0667C197.118 80.6494 196.35 80.9408 195.422 80.9408Z"
			fill="currentColor"></path>
		<path
			d="M203.473 102.952V83.2452H208.399V85.8276H209.115C209.432 85.139 210.028 84.4901 210.903 83.8809C211.777 83.2452 213.101 82.9273 214.876 82.9273C216.412 82.9273 217.749 83.2849 218.888 84C220.054 84.6887 220.954 85.6555 221.59 86.9004C222.226 88.1188 222.544 89.5491 222.544 91.1913V102.952H217.538V91.5886C217.538 90.1053 217.167 88.9929 216.425 88.2512C215.71 87.5096 214.677 87.1388 213.326 87.1388C211.79 87.1388 210.598 87.6553 209.75 88.6883C208.903 89.6948 208.479 91.1118 208.479 92.9394V102.952H203.473Z"
			fill="currentColor"></path>
		<path
			d="M234.961 102.952C233.663 102.952 232.604 102.554 231.782 101.76C230.988 100.939 230.591 99.8526 230.591 98.5017V87.3771H225.664V83.2452H230.591V77.1267H235.597V83.2452H241V87.3771H235.597V97.6276C235.597 98.4222 235.967 98.8196 236.709 98.8196H240.523V102.952H234.961Z"
			fill="currentColor"></path>
	</svg>
)

export const MoonIcon = () => (
	<svg viewBox="0 0 249.8 248.8" xmlns="http://www.w3.org/2000/svg">
		<path
			fill="currentColor"
			d="M249.8 151.1c-2.1 6.3-3.9 12.7-6.4 18.8-7.2 17.9-18.1 33.4-32.5 46.2-14.9 13.3-32.1 22.7-51.3 27.9-18.5 5.1-37.4 6.3-56.2 2.3-48.7-10.1-81.2-39.1-97.4-86-6.2-17.9-7.3-36.5-4.7-55.4 3-21.8 11.1-41.5 24.4-59C39.1 28.3 56.2 15 76.6 6.2 81.7 4.1 87 2.4 92.2.6c4.2-1.4 8.1-.3 10.3 2.8 2.3 3.2 2.1 6.9-.8 10.5-9.8 12.2-15.8 26-18.4 41.4-2.7 15.7-1.6 31.1 3.4 46.2 5.6 16.7 15.1 30.7 28.5 42 13 11 28 17.9 44.8 20.7 15.8 2.7 31.2 1.5 46.3-3.8 10.5-3.7 20.1-9.1 28.7-16.1 2.5-2.1 5.3-3.4 8.8-2.6 3.1.7 4.6 3 6 5.5v3.9z"></path>
	</svg>
)
export const ArrowLeftIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15.8318 9.16758H6.52344L10.5901 5.10091C10.9151 4.77591 10.9151 4.24258 10.5901 3.91758C10.2651 3.59258 9.74011 3.59258 9.4151 3.91758L3.92344 9.40925C3.59844 9.73425 3.59844 10.2592 3.92344 10.5842L9.4151 16.0759C9.74011 16.4009 10.2651 16.4009 10.5901 16.0759C10.9151 15.7509 10.9151 15.2259 10.5901 14.9009L6.52344 10.8342H15.8318C16.2901 10.8342 16.6651 10.4592 16.6651 10.0009C16.6651 9.54258 16.2901 9.16758 15.8318 9.16758Z"
			fill="currentColor"
		/>
	</svg>
)

export const CircleFilledIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<circle cx="8" cy="8" r="6" fill="currentColor" />
	</svg>
)

export const SunIcon = () => (
	<svg viewBox="0 0 241.5 241.5" xmlns="http://www.w3.org/2000/svg">
		<path
			fill="currentColor"
			d="M0 118.8c2-5 5.8-6.7 11-6.5 6.8.2 13.7 0 20.5.1 1.9 0 3.9.5 5.6 1.3 3.1 1.6 4.6 5.2 3.9 8.6-.6 3.2-3.4 5.9-6.7 6.5-1.1.2-2.2.2-3.3.2-6.7 0-13.4-.2-20 .1-5.2.2-9-1.5-11-6.5v-3.8zm118.9 122.7c-5-2-6.7-5.8-6.5-11 .2-6.8 0-13.7.1-20.5 0-1.9.5-3.9 1.3-5.6 1.6-3.1 5.2-4.6 8.6-3.9 3.2.6 5.9 3.4 6.5 6.7.2 1.1.2 2.2.2 3.3 0 6.7-.2 13.4.1 20 .2 5.2-1.5 9-6.5 11h-3.8zm62.6-120.7c-.2 33.3-27.7 60.9-60.7 60.6-34-.3-60.8-27.6-60.6-60.9.1-33 26.8-60.6 60.8-60.4 33.3.1 60.7 27.8 60.5 60.7zM112.6 20.5c0-4.4-.2-8.8.1-13.2.2-3.8 3.3-6.7 7-7.3 3.4-.5 6.9 1.4 8.5 4.6.4.8.7 1.6.7 2.5.1 8.9.2 17.9 0 26.8-.1 3.8-3.4 6.7-7 7.1-3.9.4-7.4-1.7-8.7-5.3-.5-1.3-.6-2.8-.6-4.2-.1-3.7 0-7.4 0-11.1-.1.1-.1.1 0 .1zm108.2 108.4c-4.5 0-9 .2-13.4-.1-3.6-.2-6.4-3.3-6.9-6.8-.5-3.6 1.2-7 4.4-8.6 1.2-.6 2.7-1 4.1-1 8-.1 16-.1 24 0 4.9.1 8.5 3.8 8.5 8.3 0 4.5-3.6 8.1-8.5 8.3-4.1.2-8.2 0-12.2 0v-.1zm-12.2 70.3c-.4 4.4-1.8 6.8-4.7 8.3-2.9 1.5-5.8 1.2-8.4-.8-1.5-1.1-2.8-2.6-4.1-3.9-4.7-4.6-9.4-9.3-14-14-3.7-3.7-3.7-8.6-.3-11.9 3.3-3.3 8.1-3.2 11.8.4 5.6 5.6 11.3 11.1 16.8 16.9 1.4 1.6 2.2 3.9 2.9 5zM66.6 57.5c-.2 4.5-1.7 7-4.6 8.5-2.9 1.5-5.8 1.2-8.4-.8-1.5-1.1-2.8-2.5-4.1-3.9-4.7-4.7-9.4-9.3-14-14-3.6-3.7-3.7-8.7-.3-12 3.4-3.3 8.1-3.1 11.8.5 5.6 5.6 11.3 11.1 16.8 16.9 1.5 1.6 2.3 3.8 2.8 4.8zm108.3.1c.5-1 1.1-3.1 2.5-4.6 5.7-6 11.6-11.8 17.5-17.5 3.4-3.3 8.2-3.3 11.4-.1 3.2 3.1 3.4 8.1.1 11.4-5.7 5.9-11.6 11.8-17.5 17.5-2.5 2.5-5.7 3.4-9.1 1.9-3.1-1.4-4.7-4-4.9-8.6zM66.6 183.9c-.5 1-1.2 3.1-2.6 4.6-5.7 6-11.6 11.8-17.5 17.5-3.4 3.3-8.2 3.2-11.4 0-3.1-3.1-3.3-8-.2-11.3 5.8-6.1 11.8-12 17.8-17.8 2.5-2.4 5.7-3.2 8.9-1.6 3.3 1.4 4.9 4 5 8.6z"></path>
	</svg>
)

export const PlusCircleIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.0003 1.66675C5.40033 1.66675 1.66699 5.40008 1.66699 10.0001C1.66699 14.6001 5.40033 18.3334 10.0003 18.3334C14.6003 18.3334 18.3337 14.6001 18.3337 10.0001C18.3337 5.40008 14.6003 1.66675 10.0003 1.66675ZM13.3337 10.8334H10.8337V13.3334C10.8337 13.7917 10.4587 14.1667 10.0003 14.1667C9.54199 14.1667 9.16699 13.7917 9.16699 13.3334V10.8334H6.66699C6.20866 10.8334 5.83366 10.4584 5.83366 10.0001C5.83366 9.54175 6.20866 9.16675 6.66699 9.16675H9.16699V6.66675C9.16699 6.20842 9.54199 5.83342 10.0003 5.83342C10.4587 5.83342 10.8337 6.20842 10.8337 6.66675V9.16675H13.3337C13.792 9.16675 14.167 9.54175 14.167 10.0001C14.167 10.4584 13.792 10.8334 13.3337 10.8334Z"
			fill="currentColor"
		/>
	</svg>
)
export const BellIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.9996 22C13.0996 22 13.9996 21.1 13.9996 20H9.99956C9.99956 21.1 10.8896 22 11.9996 22ZM17.9996 16V11C17.9996 7.93 16.3596 5.36 13.4996 4.68V4C13.4996 3.17 12.8296 2.5 11.9996 2.5C11.1696 2.5 10.4996 3.17 10.4996 4V4.68C7.62956 5.36 5.99956 7.92 5.99956 11V16L4.70956 17.29C4.07956 17.92 4.51956 19 5.40956 19H18.5796C19.4696 19 19.9196 17.92 19.2896 17.29L17.9996 16Z"
			fill="currentColor"
		/>
	</svg>
)

export const DoubleArrows = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4.78409 0.325883L7.66969 3.21148C8.37159 3.91338 7.88137 5.11664 6.88979 5.11664H1.1186C0.127024 5.11664 -0.374334 3.91338 0.327568 3.21148L3.21316 0.325883C3.64768 -0.108628 4.34958 -0.108628 4.78409 0.325883ZM3.21591 13.4334L0.330314 10.5478C-0.371588 9.84588 0.118629 8.64262 1.11021 8.64262H6.8814C7.87298 8.64262 8.37433 9.84588 7.67243 10.5478L4.78684 13.4334C4.35232 13.8679 3.65042 13.8679 3.21591 13.4334Z"
			fill="currentColor"
		/>
	</svg>
)
export const SearchIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M13.4172 11.6667H12.7589L12.5255 11.4417C13.5255 10.275 14.0422 8.68337 13.7589 6.9917C13.3672 4.67503 11.4339 2.82503 9.10052 2.5417C5.57552 2.10837 2.60885 5.07503 3.04219 8.60003C3.32552 10.9334 5.17552 12.8667 7.49219 13.2584C9.18386 13.5417 10.7755 13.025 11.9422 12.025L12.1672 12.2584V12.9167L15.7089 16.4584C16.0505 16.8 16.6089 16.8 16.9505 16.4584C17.2922 16.1167 17.2922 15.5584 16.9505 15.2167L13.4172 11.6667ZM8.41719 11.6667C6.34219 11.6667 4.66719 9.9917 4.66719 7.9167C4.66719 5.8417 6.34219 4.1667 8.41719 4.1667C10.4922 4.1667 12.1672 5.8417 12.1672 7.9167C12.1672 9.9917 10.4922 11.6667 8.41719 11.6667Z"
			fill="currentColor"
		/>
	</svg>
)
export const SquareDashIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3 15.8333V4.16667C3 3.25 3.74167 2.5 4.66667 2.5H16.3333C17.25 2.5 18 3.25 18 4.16667V15.8333C18 16.75 17.25 17.5 16.3333 17.5H4.66667C3.74167 17.5 3 16.75 3 15.8333ZM12.6131 5.46856C12.196 5.27405 11.7002 5.45451 11.5056 5.87163L7.98383 13.4242C7.78932 13.8413 7.96979 14.3371 8.3869 14.5316C8.80402 14.7261 9.29984 14.5457 9.49434 14.1286L13.0162 6.57599C13.2107 6.15888 13.0302 5.66306 12.6131 5.46856Z"
			fill="currentColor"
		/>
	</svg>
)

export const PersonIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z"
			fill="currentColor"
		/>
	</svg>
)
export const ErrorCircleIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 13C11.45 13 11 12.55 11 12V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V12C13 12.55 12.55 13 12 13ZM13 17H11V15H13V17Z"
			fill="currentColor"
		/>
	</svg>
)
export const LinkArrowIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
		<path
			d="M6.66714 3.99992C6.66714 4.37325 6.96714 4.66659 7.3338 4.66659H11.0605L3.80047 11.9266C3.54047 12.1866 3.54047 12.6066 3.80047 12.8666C4.06047 13.1266 4.48047 13.1266 4.74047 12.8666L12.0005 5.60659V9.33325C12.0005 9.69992 12.3005 9.99992 12.6671 9.99992C13.0338 9.99992 13.3338 9.69992 13.3338 9.33325V3.99992C13.3338 3.63325 13.0338 3.33325 12.6671 3.33325H7.3338C6.96714 3.33325 6.66714 3.63325 6.66714 3.99992Z"
			fill="currentColor"
		/>
	</svg>
)

export const MegaphoneIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
		<path
			d="M20.305 4.40893C20.3075 4.41143 20.31 4.41393 20.31 4.41893C20.63 4.85893 20.55 5.47893 20.12 5.79893C19.9633 5.91722 19.8039 6.03813 19.6435 6.15985C19.2614 6.44975 18.8733 6.74426 18.5 7.01893C18.06 7.34893 17.45 7.25893 17.12 6.81893C17.12 6.81393 17.1175 6.81143 17.115 6.80893C17.1125 6.80643 17.11 6.80393 17.11 6.79893C16.78 6.36893 16.86 5.74893 17.3 5.41893C17.6312 5.16416 17.9827 4.90128 18.3312 4.64062C18.5299 4.49203 18.7276 4.34416 18.92 4.19893C19.35 3.86893 19.97 3.95893 20.3 4.39893C20.3 4.40393 20.3025 4.40643 20.305 4.40893Z"
			fill="currentColor"
		/>
		<path
			d="M18.5 11.6089C18.5 12.1589 18.95 12.6089 19.5 12.6089H21.5C22.05 12.6089 22.5 12.1589 22.5 11.6089C22.5 11.0589 22.05 10.6089 21.5 10.6089H19.5C18.95 10.6089 18.5 11.0589 18.5 11.6089Z"
			fill="currentColor"
		/>
		<path
			d="M17.09 16.4288C16.76 16.8688 16.85 17.4788 17.29 17.7988C17.82 18.1888 18.38 18.6088 18.91 19.0088C19.35 19.3388 19.97 19.2488 20.29 18.8088C20.29 18.8038 20.2925 18.8013 20.295 18.7988C20.2975 18.7963 20.3 18.7938 20.3 18.7888C20.63 18.3488 20.54 17.7288 20.1 17.4088C19.5718 17.0101 19.0137 16.5915 18.4952 16.2026L18.49 16.1988C18.05 15.8688 17.43 15.9688 17.1 16.4088C17.1 16.4188 17.09 16.4288 17.09 16.4288Z"
			fill="currentColor"
		/>
		<path
			d="M8.5 8.60889H4.5C3.4 8.60889 2.5 9.50889 2.5 10.6089V12.6089C2.5 13.7089 3.4 14.6089 4.5 14.6089H5.5V17.6089C5.5 18.1589 5.95 18.6089 6.5 18.6089C7.05 18.6089 7.5 18.1589 7.5 17.6089V14.6089H8.5L13.5 17.6089V5.60889L8.5 8.60889Z"
			fill="currentColor"
		/>
		<path
			d="M14.5 8.25879C15.42 9.07879 16 10.2788 16 11.6088C16 12.9388 15.42 14.1388 14.5 14.9488V8.25879Z"
			fill="currentColor"
		/>
	</svg>
)
export const LocationIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.5 2C8.63 2 5.5 5.13 5.5 9C5.5 13.17 9.92 18.92 11.74 21.11C12.14 21.59 12.87 21.59 13.27 21.11C15.08 18.92 19.5 13.17 19.5 9C19.5 5.13 16.37 2 12.5 2ZM12.5 11.5C11.12 11.5 10 10.38 10 9C10 7.62 11.12 6.5 12.5 6.5C13.88 6.5 15 7.62 15 9C15 10.38 13.88 11.5 12.5 11.5Z"
			fill="currentColor"
		/>
	</svg>
)
export const CheckIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.00031 8.08491L3.26531 6.34991C3.07031 6.15491 2.75531 6.15491 2.56031 6.34991C2.36531 6.54491 2.36531 6.85991 2.56031 7.05491L4.65031 9.14491C4.84531 9.33991 5.16031 9.33991 5.35531 9.14491L10.6453 3.85491C10.8403 3.65991 10.8403 3.34491 10.6453 3.14991C10.4503 2.95491 10.1353 2.95491 9.94031 3.14991L5.00031 8.08491Z"
			fill="currentColor"
		/>
	</svg>
)
export const CheckCircleIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.99967 1.33325C4.31967 1.33325 1.33301 4.31992 1.33301 7.99992C1.33301 11.6799 4.31967 14.6666 7.99967 14.6666C11.6797 14.6666 14.6663 11.6799 14.6663 7.99992C14.6663 4.31992 11.6797 1.33325 7.99967 1.33325ZM6.19294 10.8599L3.7996 8.46656C3.5396 8.20656 3.5396 7.78657 3.7996 7.52657C4.0596 7.26657 4.4796 7.26657 4.7396 7.52657L6.66627 9.44656L11.2529 4.8599C11.5129 4.5999 11.9329 4.5999 12.1929 4.8599C12.4529 5.1199 12.4529 5.5399 12.1929 5.7999L7.13294 10.8599C6.8796 11.1199 6.45294 11.1199 6.19294 10.8599Z"
			fill="currentColor"
		/>
	</svg>
)
export const CropSquareIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.9993 2.66675H3.99935C3.26602 2.66675 2.66602 3.26675 2.66602 4.00008V12.0001C2.66602 12.7334 3.26602 13.3334 3.99935 13.3334H11.9993C12.7327 13.3334 13.3327 12.7334 13.3327 12.0001V4.00008C13.3327 3.26675 12.7327 2.66675 11.9993 2.66675ZM11.3327 12.0001H4.66602C4.29935 12.0001 3.99935 11.7001 3.99935 11.3334V4.66675C3.99935 4.30008 4.29935 4.00008 4.66602 4.00008H11.3327C11.6993 4.00008 11.9993 4.30008 11.9993 4.66675V11.3334C11.9993 11.7001 11.6993 12.0001 11.3327 12.0001Z"
			fill="currentColor"
		/>
	</svg>
)
export const TimelapseIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.8273 5.17325C10.0473 4.39325 9.02732 3.99992 8.00065 3.99992V7.99992L5.17398 10.8266C6.73398 12.3866 9.26732 12.3866 10.834 10.8266C12.394 9.26659 12.394 6.73325 10.8273 5.17325ZM8.00065 1.33325C4.32065 1.33325 1.33398 4.31992 1.33398 7.99992C1.33398 11.6799 4.32065 14.6666 8.00065 14.6666C11.6807 14.6666 14.6673 11.6799 14.6673 7.99992C14.6673 4.31992 11.6807 1.33325 8.00065 1.33325ZM8.00065 13.3333C5.05398 13.3333 2.66732 10.9466 2.66732 7.99992C2.66732 5.05325 5.05398 2.66659 8.00065 2.66659C10.9473 2.66659 13.334 5.05325 13.334 7.99992C13.334 10.9466 10.9473 13.3333 8.00065 13.3333Z"
			fill="currentColor"
		/>
	</svg>
)

export const ChevronRightIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.75742 5.59173C7.43242 5.91673 7.43242 6.44173 7.75742 6.76673L10.9908 10.0001L7.75742 13.2334C7.43242 13.5584 7.43242 14.0834 7.75742 14.4084C8.08242 14.7334 8.60742 14.7334 8.93242 14.4084L12.7574 10.5834C13.0824 10.2584 13.0824 9.73339 12.7574 9.40839L8.93242 5.58339C8.61576 5.26673 8.08242 5.26673 7.75742 5.59173Z"
			fill="currentColor"
		/>
	</svg>
)
export const DropdownArrowIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.41289 11.3815L11.0199 14.9885C11.563 15.5316 12.4404 15.5316 12.9835 14.9885L16.5905 11.3815C17.4679 10.5041 16.8412 9 15.6017 9H8.38776C7.14829 9 6.53552 10.5041 7.41289 11.3815Z"
			fill="currentColor"
		/>
	</svg>
)
export const CloudUploadIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.873 8.86658C16.3064 5.99159 13.7814 3.83325 10.748 3.83325C8.33971 3.83325 6.24805 5.19992 5.20638 7.19992C2.69805 7.46658 0.748047 9.59158 0.748047 12.1666C0.748047 14.9249 2.98971 17.1666 5.74805 17.1666H16.5814C18.8814 17.1666 20.748 15.2999 20.748 12.9999C20.748 10.7999 19.0397 9.01658 16.873 8.86658ZM12.4147 11.3332V14.6666H9.08138V11.3332H6.58138L10.4564 7.45822C10.623 7.29155 10.8814 7.29155 11.048 7.45822L14.9147 11.3332H12.4147Z"
			fill="currentColor"
		/>
	</svg>
)
export const VideoLibraryIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3 6C2.45 6 2 6.45 2 7V20C2 21.1 2.9 22 4 22H17C17.55 22 18 21.55 18 21C18 20.45 17.55 20 17 20H5C4.45 20 4 19.55 4 19V7C4 6.45 3.55 6 3 6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM12 14.5V5.5L17.47 9.6C17.74 9.8 17.74 10.2 17.47 10.4L12 14.5Z"
			fill="currentColor"
		/>
	</svg>
)
export const ReplayIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M24.0001 12.0001V6.42006C24.0001 5.52006 22.9201 5.08006 22.3001 5.72006L14.7001 13.3001C14.3001 13.7001 14.3001 14.3201 14.7001 14.7201L22.2801 22.3001C22.9201 22.9201 24.0001 22.4801 24.0001 21.5801V16.0001C31.4601 16.0001 37.3601 22.8401 35.7201 30.5801C34.7801 35.1201 31.1001 38.7801 26.5801 39.7201C19.4401 41.2201 13.0801 36.3201 12.1201 29.7001C11.9801 28.7401 11.1401 28.0001 10.1601 28.0001C8.96006 28.0001 8.00006 29.0601 8.16006 30.2601C9.40006 39.0401 17.7601 45.5401 27.2201 43.7001C33.4601 42.4801 38.4801 37.4601 39.7001 31.2201C41.6801 20.9601 33.8801 12.0001 24.0001 12.0001Z"
			fill="currentColor"
		/>
	</svg>
)
export const FilmReelIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			d="M18 4V5H16V4C16 3.45 15.55 3 15 3H9C8.45 3 8 3.45 8 4V5H6V4C6 3.45 5.55 3 5 3C4.45 3 4 3.45 4 4V20C4 20.55 4.45 21 5 21C5.55 21 6 20.55 6 20V19H8V20C8 20.55 8.45 21 9 21H15C15.55 21 16 20.55 16 20V19H18V20C18 20.55 18.45 21 19 21C19.55 21 20 20.55 20 20V4C20 3.45 19.55 3 19 3C18.45 3 18 3.45 18 4ZM8 17H6V15H8V17ZM8 13H6V11H8V13ZM8 9H6V7H8V9ZM18 17H16V15H18V17ZM18 13H16V11H18V13ZM18 9H16V7H18V9Z"
			fill="currentColor"
		/>
	</svg>
)
export const DeleteIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4.99935 15.8333C4.99935 16.75 5.74935 17.5 6.66602 17.5H13.3327C14.2493 17.5 14.9993 16.75 14.9993 15.8333V7.5C14.9993 6.58333 14.2493 5.83333 13.3327 5.83333H6.66602C5.74935 5.83333 4.99935 6.58333 4.99935 7.5V15.8333ZM14.9993 3.33333H12.916L12.3243 2.74167C12.1743 2.59167 11.9577 2.5 11.741 2.5H8.25768C8.04102 2.5 7.82435 2.59167 7.67435 2.74167L7.08268 3.33333H4.99935C4.54102 3.33333 4.16602 3.70833 4.16602 4.16667C4.16602 4.625 4.54102 5 4.99935 5H14.9993C15.4577 5 15.8327 4.625 15.8327 4.16667C15.8327 3.70833 15.4577 3.33333 14.9993 3.33333Z"
			fill="currentColor"
		/>
	</svg>
)
export const CompanyIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 3H20C20.55 3 21 3.45 21 4V20C21 20.55 20.55 21 20 21H17V19H19V17H17V15H19V13H17V12.35C17 11.5 16.64 10.68 16.01 10.12L11.01 5.62L11 5.61V4C11 3.45 11.45 3 12 3ZM13 7H15V5H13V7ZM17 11H19V9H17V11ZM17 7H19V5H17V7ZM15 12.3501V20.0001C15 20.5501 14.55 21.0001 14 21.0001H12C11.45 21.0001 11 20.5501 11 20.0001V16.0001H7V20.0001C7 20.5501 6.55 21.0001 6 21.0001H4C3.45 21.0001 3 20.5501 3 20.0001V12.3501C3 12.0601 3.12 11.7901 3.33 11.6101L8.33 7.1101C8.52 6.9401 8.76 6.8501 9 6.8501C9.24 6.8501 9.48 6.9301 9.67 7.1101L14.67 11.6101C14.88 11.8001 15 12.0701 15 12.3501Z"
			fill="currentColor"
		/>
	</svg>
)
export const CityIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15 11V5.82998C15 5.29998 14.79 4.78998 14.41 4.41998L12.7 2.70998C12.31 2.31998 11.68 2.31998 11.29 2.70998L9.59 4.40998C9.21 4.78998 9 5.29998 9 5.82998V6.99998H5C3.9 6.99998 3 7.89998 3 8.99998V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13C21 11.9 20.1 11 19 11H15ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V8.99998H7V11ZM13 19H11V17H13V19ZM13 15H11V13H13V15ZM13 11H11V8.99998H13V11ZM13 6.99998H11V4.99998H13V6.99998ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z"
			fill="currentColor"
		/>
	</svg>
)
export const MoreHorizontalIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
			fill="currentColor"
		/>
	</svg>
)
export const CompareArrowIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.01 14H3C2.45 14 2 14.45 2 15C2 15.55 2.45 16 3 16H9.01V17.79C9.01 18.24 9.55 18.46 9.86 18.14L12.64 15.35C12.83 15.15 12.83 14.84 12.64 14.64L9.86 11.85C9.55 11.53 9.01 11.76 9.01 12.2V14ZM14.99 11.79V10H21C21.55 10 22 9.55003 22 9.00003C22 8.45003 21.55 8.00003 21 8.00003H14.99V6.21003C14.99 5.76003 14.45 5.54003 14.14 5.86003L11.36 8.65003C11.17 8.85003 11.17 9.16003 11.36 9.36003L14.14 12.15C14.45 12.46 14.99 12.24 14.99 11.79Z"
			fill="currentColor"
		/>
	</svg>
)
export const ArchiveIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.27 2.615L9.575 1.775C9.44 1.605 9.235 1.5 9 1.5H3C2.765 1.5 2.56 1.605 2.42 1.775L1.73 2.615C1.585 2.785 1.5 3.01 1.5 3.25V9.5C1.5 10.05 1.95 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V3.25C10.5 3.01 10.415 2.785 10.27 2.615ZM5.825 8.575L3.25 6H5V5H7V6H8.75L6.175 8.575C6.08 8.67 5.92 8.67 5.825 8.575ZM2.56 2.5L2.965 2H8.965L9.435 2.5H2.56Z"
			fill="currentColor"
		/>
	</svg>
)
export const InfoIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 8.5C5.725 8.5 5.5 8.275 5.5 8V6C5.5 5.725 5.725 5.5 6 5.5C6.275 5.5 6.5 5.725 6.5 6V8C6.5 8.275 6.275 8.5 6 8.5ZM6.5 4.5H5.5V3.5H6.5V4.5Z"
			fill="currentColor"
		/>
	</svg>
)
export const WarningIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M4.47012 21.0002H19.5301C21.0701 21.0002 22.0301 19.3302 21.2601 18.0002L13.7301 4.99018C12.9601 3.66018 11.0401 3.66018 10.2701 4.99018L2.74012 18.0002C1.97012 19.3302 2.93012 21.0002 4.47012 21.0002ZM12.0001 14.0002C11.4501 14.0002 11.0001 13.5502 11.0001 13.0002V11.0002C11.0001 10.4502 11.4501 10.0002 12.0001 10.0002C12.5501 10.0002 13.0001 10.4502 13.0001 11.0002V13.0002C13.0001 13.5502 12.5501 14.0002 12.0001 14.0002ZM13.0001 18.0002H11.0001V16.0002H13.0001V18.0002Z"
			fill="currentColor"
		/>
	</svg>
)
export const RecIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M6 1C8.76 1 11 3.24 11 6C11 8.76 8.76 11 6 11C3.24 11 1 8.76 1 6C1 3.24 3.24 1 6 1ZM6 10C8.21 10 10 8.21 10 6C10 3.79 8.21 2 6 2C3.79 2 2 3.79 2 6C2 8.21 3.79 10 6 10ZM6 8.5C4.61929 8.5 3.5 7.38071 3.5 6C3.5 4.61929 4.61929 3.5 6 3.5C7.38071 3.5 8.5 4.61929 8.5 6C8.5 7.38071 7.38071 8.5 6 8.5Z"
			fill="currentColor"
		/>
	</svg>
)
export const CloseIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M18.3007 5.70997C17.9107 5.31997 17.2807 5.31997 16.8907 5.70997L12.0007 10.59L7.1107 5.69997C6.7207 5.30997 6.0907 5.30997 5.7007 5.69997C5.3107 6.08997 5.3107 6.71997 5.7007 7.10997L10.5907 12L5.7007 16.89C5.3107 17.28 5.3107 17.91 5.7007 18.3C6.0907 18.69 6.7207 18.69 7.1107 18.3L12.0007 13.41L16.8907 18.3C17.2807 18.69 17.9107 18.69 18.3007 18.3C18.6907 17.91 18.6907 17.28 18.3007 16.89L13.4107 12L18.3007 7.10997C18.6807 6.72997 18.6807 6.08997 18.3007 5.70997Z"
			fill="currentColor"
		/>
	</svg>
)
export const PlayCircleIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.8 15.9L15.47 12.4C15.74 12.2 15.74 11.8 15.47 11.6L10.8 8.1C10.47 7.85 10 8.09 10 8.5V15.5C10 15.91 10.47 16.15 10.8 15.9ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
			fill="currentColor"
		/>
	</svg>
)
export const ImageIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.9 13.98L11 16.51L14.1 12.52C14.3 12.26 14.7 12.26 14.9 12.53L18.41 17.21C18.66 17.54 18.42 18.01 18.01 18.01H6.02C5.6 18.01 5.37 17.53 5.63 17.2L8.12 14C8.31 13.74 8.69 13.73 8.9 13.98Z"
			fill="currentColor"
		/>
	</svg>
)
export const ImageInnerIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.2 1.07004L8.25001 5.00004L10.5 8.00004C10.83 8.44004 10.74 9.07004 10.3 9.40004C9.86001 9.73004 9.23001 9.65004 8.90001 9.20004C7.85001 7.80004 6.59001 6.13004 5.80001 5.06004C5.40001 4.53004 4.60001 4.53004 4.20001 5.06004L0.200007 10.39C-0.289993 11.06 0.180008 12 1.00001 12H19C19.82 12 20.29 11.06 19.8 10.4L12.8 1.07004C12.4 0.530039 11.6 0.530039 11.2 1.07004Z"
			fill="currentColor"
		/>
	</svg>
)
export const MonitorIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			d="M20 3H4C2.9 3 2 3.9 2 5V16C2 17.1 2.9 18 4 18H7L6 19V21H18V19L17 18H20C21.1 18 22 17.1 22 16V5C22 3.9 21.1 3 20 3ZM20 16H4V5H20V16Z"
			fill="currentColor"
		/>
	</svg>
)
export const SubdirectoryArrowRightIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M18.29 15.71L13.71 20.29C13.32 20.68 12.68 20.68 12.29 20.29C11.9 19.9 11.9 19.26 12.29 18.87L15.17 16H5C4.45 16 4 15.55 4 15V5C4 4.45 4.45 4 5 4C5.55 4 6 4.45 6 5V14H15.17L12.29 11.13C11.9 10.74 11.9 10.1 12.29 9.71C12.68 9.32 13.32 9.32 13.71 9.71L18.29 14.29C18.68 14.68 18.68 15.32 18.29 15.71Z"
			fill="currentColor"
		/>
	</svg>
)

export const addNewMediaIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3 6C2.45 6 2 6.45 2 7V20C2 21.1 2.9 22 4 22H17C17.55 22 18 21.55 18 21C18 20.45 17.55 20 17 20H5C4.45 20 4 19.55 4 19V7C4 6.45 3.55 6 3 6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM18 11H15V14C15 14.55 14.55 15 14 15C13.45 15 13 14.55 13 14V11H10C9.45 11 9 10.55 9 10C9 9.45 9.45 9 10 9H13V6C13 5.45 13.45 5 14 5C14.55 5 15 5.45 15 6V9H18C18.55 9 19 9.45 19 10C19 10.55 18.55 11 18 11Z"
			fill="currentColor"
		/>
	</svg>
)

export const uploadIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			d="M10 16.0002H14C14.55 16.0002 15 15.5502 15 15.0002V10.0002H16.59C17.48 10.0002 17.93 8.92021 17.3 8.29021L12.71 3.70021C12.32 3.31021 11.69 3.31021 11.3 3.70021L6.71 8.29021C6.08 8.92021 6.52 10.0002 7.41 10.0002H9V15.0002C9 15.5502 9.45 16.0002 10 16.0002ZM6 18.0002H18C18.55 18.0002 19 18.4502 19 19.0002C19 19.5502 18.55 20.0002 18 20.0002H6C5.45 20.0002 5 19.5502 5 19.0002C5 18.4502 5.45 18.0002 6 18.0002Z"
			fill="currentColor"
		/>
	</svg>
)
export const PencilICon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M3 17.4601V20.5001C3 20.7801 3.22 21.0001 3.5 21.0001H6.54C6.67 21.0001 6.8 20.9501 6.89 20.8501L17.81 9.94006L14.06 6.19006L3.15 17.1001C3.05 17.2001 3 17.3201 3 17.4601ZM20.71 7.04006C21.1 6.65006 21.1 6.02006 20.71 5.63006L18.37 3.29006C17.98 2.90006 17.35 2.90006 16.96 3.29006L15.13 5.12006L18.88 8.87006L20.71 7.04006Z"
			fill="currentColor"
		/>
	</svg>
)
export const LogoutIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.79 16.29C11.18 16.68 11.81 16.68 12.2 16.29L15.79 12.7C16.18 12.31 16.18 11.68 15.79 11.29L12.2 7.7C11.81 7.31 11.18 7.31 10.79 7.7C10.4 8.09 10.4 8.72 10.79 9.11L12.67 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13H12.67L10.79 14.88C10.4 15.27 10.41 15.91 10.79 16.29ZM19 3H5C3.89 3 3 3.9 3 5V8C3 8.55 3.45 9 4 9C4.55 9 5 8.55 5 8V6C5 5.45 5.45 5 6 5H18C18.55 5 19 5.45 19 6V18C19 18.55 18.55 19 18 19H6C5.45 19 5 18.55 5 18V16C5 15.45 4.55 15 4 15C3.45 15 3 15.45 3 16V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
			fill="currentColor"
		/>
	</svg>
)
export const BurgerIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path fill-rule="evenodd" clip-rule="evenodd"
					d="M4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7Z"
					fill="currentColor" />
	</svg>
)

export const PrintIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path fill-rule="evenodd" clip-rule="evenodd"
					d="M19 8H5C3.34 8 2 9.34 2 11V15C2 16.1 2.9 17 4 17H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V17H20C21.1 17 22 16.1 22 15V11C22 9.34 20.66 8 19 8ZM15 19H9C8.45 19 8 18.55 8 18V14H16V18C16 18.55 15.55 19 15 19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM17 3H7C6.45 3 6 3.45 6 4V6C6 6.55 6.45 7 7 7H17C17.55 7 18 6.55 18 6V4C18 3.45 17.55 3 17 3Z"
					fill="currentColor" />
	</svg>
)

export const UndoIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path fill-rule="evenodd" clip-rule="evenodd"
					d="M12.5 8C9.85 8 7.45 8.99 5.6 10.6L3.71 8.71C3.08 8.08 2 8.52 2 9.41V15C2 15.55 2.45 16 3 16H8.59C9.48 16 9.93 14.92 9.3 14.29L7.39 12.38C8.78 11.22 10.55 10.5 12.51 10.5C15.67 10.5 18.4 12.34 19.7 15C19.97 15.56 20.61 15.84 21.2 15.64C21.91 15.41 22.27 14.6 21.95 13.92C20.23 10.42 16.65 8 12.5 8Z"
					fill="currentColor" />
	</svg>
)
export const FileIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path
			d="M19 3H4.99C3.89 3 3 3.9 3 5L3.01 19C3.01 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM8 8H16C16.55 8 17 8.45 17 9C17 9.55 16.55 10 16 10H8C7.45 10 7 9.55 7 9C7 8.45 7.45 8 8 8ZM11 14H8C7.45 14 7 13.55 7 13C7 12.45 7.45 12 8 12H11C11.55 12 12 12.45 12 13C12 13.55 11.55 14 11 14ZM14 19.5V15C14 14.45 14.45 14 15 14H19.5L14 19.5Z"
			fill="currentColor" />
	</svg>
)

export const CardIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path fill-rule="evenodd" clip-rule="evenodd"
					d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM19 18H5C4.45 18 4 17.55 4 17V12H20V17C20 17.55 19.55 18 19 18ZM20 8H4V7C4 6.45 4.45 6 5 6H19C19.55 6 20 6.45 20 7V8Z"
					fill="currentColor" />
	</svg>
)

export const ReceiptIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
		<path fill-rule="evenodd" clip-rule="evenodd"
					d="M21 2.2102C20.87 2.2102 20.74 2.2602 20.65 2.3602L19.86 3.1502C19.66 3.3502 19.35 3.3502 19.15 3.1502L18.36 2.3602C18.16 2.1602 17.85 2.1602 17.65 2.3602L16.86 3.1502C16.66 3.3502 16.35 3.3502 16.15 3.1502L15.36 2.3602C15.16 2.1602 14.85 2.1602 14.65 2.3602L13.86 3.1502C13.66 3.3502 13.35 3.3502 13.15 3.1502L12.36 2.3602C12.16 2.1602 11.85 2.1602 11.65 2.3602L10.86 3.1502C10.66 3.3502 10.35 3.3502 10.15 3.1502L9.35 2.3502C9.15 2.1502 8.84 2.1502 8.64 2.3502L7.85 3.1502C7.65 3.3502 7.34 3.3502 7.14 3.1502L6.35 2.3502C6.15 2.1502 5.84 2.1502 5.64 2.3502L4.85 3.1502C4.65 3.3502 4.34 3.3502 4.14 3.1502L3.35 2.3502C3.26 2.2602 3.13 2.2102 3 2.2102V21.8002C3.13 21.8002 3.26 21.7502 3.35 21.6502L4.14 20.8602C4.34 20.6602 4.65 20.6602 4.85 20.8602L5.64 21.6502C5.84 21.8502 6.15 21.8502 6.35 21.6502L7.14 20.8602C7.34 20.6602 7.65 20.6602 7.85 20.8602L8.64 21.6502C8.84 21.8502 9.15 21.8502 9.35 21.6502L10.14 20.8602C10.34 20.6602 10.65 20.6602 10.85 20.8602L11.64 21.6502C11.84 21.8502 12.15 21.8502 12.35 21.6502L13.14 20.8602C13.34 20.6602 13.65 20.6602 13.85 20.8602L14.64 21.6502C14.84 21.8502 15.15 21.8502 15.35 21.6502L16.14 20.8602C16.34 20.6602 16.65 20.6602 16.85 20.8602L17.64 21.6502C17.84 21.8502 18.15 21.8502 18.35 21.6502L19.14 20.8602C19.34 20.6602 19.65 20.6602 19.85 20.8602L20.64 21.6502C20.74 21.7502 20.87 21.8002 20.99 21.8002V2.2102H21ZM17 17.0002H7C6.45 17.0002 6 16.5502 6 16.0002C6 15.4502 6.45 15.0002 7 15.0002H17C17.55 15.0002 18 15.4502 18 16.0002C18 16.5502 17.55 17.0002 17 17.0002ZM17 13.0002H7C6.45 13.0002 6 12.5502 6 12.0002C6 11.4502 6.45 11.0002 7 11.0002H17C17.55 11.0002 18 11.4502 18 12.0002C18 12.5502 17.55 13.0002 17 13.0002ZM17 9.0002H7C6.45 9.0002 6 8.5502 6 8.0002C6 7.4502 6.45 7.0002 7 7.0002H17C17.55 7.0002 18 7.4502 18 8.0002C18 8.5502 17.55 9.0002 17 9.0002Z"
					fill="currentColor" />
	</svg>
)
